import React, { useState } from 'react'
import { Container, Top } from '../../../styles'
import { DefaultAdminPage } from '../../../../DefaultPages'
import { BoxButtonsHead } from './styles'
import { BrandTabs } from '../../../../../constants/order'

import { Breadcrumbs, Tab } from '../../../../../components'
import Overview from './Overview'
import Users from './Users'

const BrandDetails = () => {
  const [tabName, setTabName] = useState(BrandTabs.ALL_VISION)

  return (
    <DefaultAdminPage page="empresas">
      <Container>
        <Top>
          <Breadcrumbs />

          <BoxButtonsHead>
            {/* <Button
              type="button"
              variant="outlined"
              text="Exportar excel"
              width="120px"
            /> */}
            {/* <Button
              type="button"
              variant="primary"
              text="Bloquear"
              width="120px"
            /> */}
          </BoxButtonsHead>
        </Top>
        <h3>Panorama Geral da empresa</h3>

        <Tab>
          <Tab.Item
            name="tabName"
            label="Visão Geral"
            onClick={() => setTabName(BrandTabs.ALL_VISION)}
            checked={tabName === BrandTabs.ALL_VISION}
          />
          <Tab.Item
            name="tabName"
            label="Usuários"
            onClick={() => setTabName(BrandTabs.USERS)}
            checked={tabName === BrandTabs.USERS}
          />
        </Tab>

        {tabName === BrandTabs.ALL_VISION && <Overview />}
        {tabName === BrandTabs.USERS && <Users />}
      </Container>
    </DefaultAdminPage>
  )
}

export default BrandDetails
